import {
    FETCH_DOCUMENT_CATEGORIES,
    FETCH_DOCUMENTS,
    DOWNLOAD_DOCUMENTS,
} from "./actions.type";
import {
    QUERY_CHANGED,
    CATEGORIES_FETCHED,
    DOCUMENTS_FETCHED,
    NO_ITEMS_FOUND
} from "./mutations.type";
import {MyDocumentsService} from "../common/api.service";
import {simpleFileDownload} from "../common/download.service";
import API_URL from "../common/config";

export function getInitialState() {
    return {
        documents: [],
        categories: [],
        results: 0,
        query: {
            category: "",
            q: "",
            sort: "",
            order: "",
            page: 0,
            pageSize: 5,
        }
    }
}

const state = getInitialState();

const getters = {
    documents(state) {
        return state.documents;
    },
    categories(state) {
        return state.categories;
    },
    results(state) {
        return state.results;
    },
    category(state) {
        return state.query.category;
    },
    page(state) {
        return state.query.page + 1;
    }
};

const actions = {
    [FETCH_DOCUMENT_CATEGORIES]({commit}) {
        return MyDocumentsService.getCategories()
            .then(response => {
                commit(CATEGORIES_FETCHED, response);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [FETCH_DOCUMENTS]({commit, state}) {
        return MyDocumentsService.getDocuments(state.query)
            .then(response => {
                commit(DOCUMENTS_FETCHED, response);
            })
            .catch(error => {
                commit(NO_ITEMS_FOUND);
                throw new Error(error);
            });
    },
    [DOWNLOAD_DOCUMENTS]({state}) {
        simpleFileDownload(API_URL + "documentlibrary/v2/documents/zip?" + new URLSearchParams(state.query));
    },
};

const mutations = {
    [CATEGORIES_FETCHED](state, response) {
        const secured = "My Documents";
        let sorted = response.data.items.sort((x, y) => {
            return x === secured ? -1 : y === secured ? 1 : 0;
        });
        state.categories = ['All', ...sorted];
        state.query.category = state.categories[0];
    },
    [QUERY_CHANGED](state, payload) {
        state.query = {...state.query, ...payload};
    },
    [DOCUMENTS_FETCHED](state, response) {
        let documents = response.data.items;
        documents.forEach(document => document.date = new Date(document.date));
        state.documents = Object.assign({}, documents);
        state.results = response.data.results;
    },
    [NO_ITEMS_FOUND](state) {
        state.documents = [];
        state.results = 0;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
